import './App.css';
import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { ToastContainer } from "react-toastify";
import VoiceProvider from './components/hooks/VoiceProvider';
import VoiceButton from './components/hooks/Voicebutton';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/home/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Wallet from './panel/Wallet';
import Addtrip from './components/trips/Addtrip';
import Paymentmode from './components/master/Paymentmode';
import Productsize from './components/master/Productsize';
import Purchaseproduct from './components/master/Purchaseproduct';
import Tripproducts from './components/master/Tripproducts';
import Usermgmt from './components/master/Usermgmt';
import Vehicalmgmt from './components/master/Vehicalmgmt';
import Expenseheads from './components/master/Expenseheads';
import Incomeheads from './components/master/Incomeheads';
import Otherincome from './components/home/Otherincome';
import Otherexpense from './components/home/Otherexpense';
import Customer from './components/trips/Customer';
import Dealer from './components/purchases/Dealer';
import Addpurchase from './components/purchases/Addpurchase';
import Viewpurchasse from './components/purchases/Viewpurchasse';
import Dealeraccount from './components/purchases/Dealeraccount';
import Staffmgmt from './components/payroll/Staffmgmt';
import Staffattendance from './components/payroll/Staffattendance';
import Advancepayment from './components/payroll/Advancepayment';
import Monthlypayment from './components/payroll/Monthlypayment';
import Viewtrips from './components/trips/Viewtrips';
import Customeracc from './components/trips/Customeracc';
import Fuelentry from './components/master/Fuelentry';
import Crusherdetails from './components/master/Crusherdetails';
import Matoshrivehicles from './components/master/Matoshrivehicles';
import Whatsapphistory from './components/home/Whatsapphistory';
import EditTrip from './components/trips/EditTrip';
import Salereport from './components/reports/Salereport';
import Purchasereport from './components/reports/Purchasereport';
import CustomerwiseReport from './components/reports/Customerwisereport';
import ProductwiseReport from './components/reports/ProductwiseReport';
import Vehicalwisereport from './components/reports/Vehicalwisereport';
import Collectionreport from './components/reports/Collectionreport';
import Salaeryreport from './components/reports/Salaeryreport';
import Datewiseoutstanding from './components/reports/Datewiseoutstanding';
import Attendancereport from './components/payroll/Attendancereport';
import Tripinvoice from './components/trips/Tripinvoice';
import Tripquotation from './components/trips/Tripquotation';
import Salaryslip from './components/payroll/Salaryslip';
import Allslaryslip from './components/payroll/Allslaryslip';
import Customersale from './components/reports/Customersale';
import Customertrips from './components/trips/Customertrips';
import Paymodewisereport from './components/reports/Paymodewisereport';
import Throughdetails from './components/master/Throughdetails';
import Throughreport from './components/reports/Throughreport';
import Pigmisaving from './components/master/Pigmisaving';
import Prodvehicals from './components/production/Prodvehicals';
import Boldertrips from './components/production/Boldertrips';
import Addloan from './components/loan/Addloan';
import Headwisestatement from './components/reports/Headwisestatement';
import Spliexpense from './components/master/Spliexpense';
import Dailyledger from './components/reports/Dailyledger';
import Monthlyreport from './components/reports/Monthlyreport';
import Rdsaving from './components/master/Rdsaving';
import Thoughcustreport from './components/trips/Thoughcustreport';
import Outstaningreport from './components/reports/Outstaningreport';

function App() {
  const [user, setUser] = useState();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="wrapper  sidebar-mini">
      <Router>
        <VoiceProvider>
          {
            !user ?
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/login' element={<Login />} />
                <Route path='/forgot-password' element={<Forgetpass />} />
                <Route path='/Register' element={<Register />} />
              </Routes>
              :
              <>
                <Header
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  mobileMenuOpen={mobileMenuOpen}
                  setMobileMenuOpen={setMobileMenuOpen}
                />
                <Menu
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  mobileMenuOpen={mobileMenuOpen}
                  setMobileMenuOpen={setMobileMenuOpen}
                />
                <div
                  className="content-wrapper p-1"
                  style={{
                    marginLeft: isMobile
                      ? "0"
                      : collapsed
                        ? "80px"
                        : "250px",

                    transition: "0.3s ease",
                    marginBottom: 50,
                    minHeight: "100vh",
                    marginTop: 50,
                  }}
                >
                  <Routes>
                    <Route path='/outstanding-report' element={<Outstaningreport />} />
                    <Route path='/haste-customer-account' element={<Thoughcustreport />} />
                    <Route path='/rd-saving' element={<Rdsaving />} />
                    <Route path='/monthly-report' element={<Monthlyreport />} />
                    <Route path='/daily-ledger-report' element={<Dailyledger />} />
                    <Route path='/split-expense' element={<Spliexpense />} />
                    <Route path='/headwise-statement' element={<Headwisestatement />} />
                    <Route path='/add-loan' element={<Addloan />} />
                    <Route path='/bolder-trips' element={<Boldertrips />} />
                    <Route path='/production-vehicals' element={<Prodvehicals />} />
                    <Route path='/pigmi-saving' element={<Pigmisaving />} />
                    <Route path='/through-report' element={<Throughreport />} />
                    <Route path='/through-details' element={<Throughdetails />} />
                    <Route path='/paymodewise-report' element={<Paymodewisereport />} />
                    <Route path='/customer-trip-history/:customerId' element={<Customertrips />} />
                    <Route path='/customer-sale-report' element={<Customersale />} />
                    <Route path='/all-staff-salary-slip' element={<Allslaryslip />} />
                    <Route path='/salary-slip' element={<Salaryslip />} />
                    <Route path='/trip-quotation' element={<Tripquotation />} />
                    <Route path='/trip-invoice' element={<Tripinvoice />} />
                    <Route path='/attendance-report' element={<Attendancereport />} />
                    <Route path='/datewise-customer-outstanding' element={<Datewiseoutstanding />} />
                    <Route path='/salary-report' element={<Salaeryreport />} />
                    <Route path='/collection-report' element={<Collectionreport />} />
                    <Route path='/vehiclewise-report' element={<Vehicalwisereport />} />
                    <Route path='/productwise-report' element={<ProductwiseReport />} />
                    <Route path='/customerwise-report' element={<CustomerwiseReport />} />
                    <Route path='/purchase-report' element={<Purchasereport />} />
                    <Route path='/sale-report' element={<Salereport />} />
                    <Route path="/edit-trip/:id" element={<EditTrip />} />
                    <Route path='/whatsapp-history' element={<Whatsapphistory />} />
                    <Route path='/view-bolder-trip' element={<Boldertrips />} />
                    <Route path='/self-vehicles' element={<Matoshrivehicles />} />
                    <Route path='/property-details' element={<Crusherdetails />} />
                    <Route path='/fuel-entry' element={<Fuelentry />} />
                    <Route path='/customer-account' element={<Customeracc />} />
                    <Route path='/view-trip' element={<Viewtrips />} />
                    <Route path='/monthly-payment' element={<Monthlypayment />} />
                    <Route path='/advance-payment' element={<Advancepayment />} />
                    <Route path='/attendance' element={<Staffattendance />} />
                    <Route path='/staff-mgmt' element={<Staffmgmt />} />
                    <Route path='/dealer-account' element={<Dealeraccount />} />
                    <Route path='/view-purchase' element={<Viewpurchasse />} />
                    <Route path='/add-purchase' element={<Addpurchase />} />
                    <Route path='/dealer-mgmt' element={<Dealer />} />
                    <Route path='/customer-mgmt' element={<Customer />} />
                    <Route path='/other-expense' element={<Otherexpense />} />
                    <Route path='/other-income' element={<Otherincome />} />
                    <Route path='/income-heads' element={<Incomeheads />} />
                    <Route path='/expense-heads' element={<Expenseheads />} />
                    <Route path='/vehicle-mgmt' element={<Vehicalmgmt />} />
                    {/* <Route path='/users-mgmt' element={<Usermgmt />} /> */}
                    <Route path='/trip-products' element={<Tripproducts />} />
                    <Route path='/purchase-products' element={<Purchaseproduct />} />
                    <Route path='/product-size' element={<Productsize />} />
                    <Route path='/payment-modes' element={<Paymentmode />} />
                    <Route path='/add-trip' element={<Addtrip />} />
                    <Route path='/wallet' element={<Wallet />} />
                    <Route path='/home' element={<Dashboard />} />
                  </Routes>

                </div>
                {/* <Footer /> */}
              </>
          }
        </VoiceProvider>

      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div >
  );
}

export default App;
